// extracted by mini-css-extract-plugin
export default {"doughnutBox__border":"DoughnutBox_doughnutBox__border__3H6aK"};